module.exports = __webpack_public_path__ + "img/audio.0bd25369.svg";